import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

interface CommentsViewProps {
  onBack: () => void;
}

export const CommentsView = ({ onBack }: CommentsViewProps) => {
  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2">
        <Button variant="ghost" size="icon" onClick={onBack}>
          <ArrowLeft className="h-4 w-4" />
        </Button>
        <h3 className="font-semibold">Your Comments</h3>
      </div>
      <div className="text-sm text-muted-foreground text-center py-8">
        Your comments will appear here
      </div>
    </div>
  );
};